export default __webpack_public_path__ + "static/media/ndvi3.030f2fdc.PNG";